import { getFormElementAPI, getFieldAPI } from '../../utils/form_element_api_builder';
import { eventsMapped } from '../../utils/behaviors_translate';

let behaviorsEventsSubscriptions = [];

export const subscribe = (formAPI, eventHandler) => {	
	const formBehaviors = formAPI.behaviors();
	
	unsubscribeFromPreviousBehaviorsEvents();
	formBehaviors.forEach(subscribeToBehaviorEvents.bind(this, formAPI, eventHandler));
};

const unsubscribeFromPreviousBehaviorsEvents = () => {
	behaviorsEventsSubscriptions.forEach((s) => s.unsubscribe());
};

const subscribeToBehaviorEvents = (formAPI, eventHandler, behavior) => {
	const { events } = behavior;	
	const eventsEnabled = (events || []).filter(e => e.enabled);	
	if (Array.isArray(eventsEnabled) && eventsEnabled.length > 0) {
		eventsEnabled.forEach(event => {
			const eventFind = eventsMapped.find(e => e.eventType === event.event_type);			
			let action_alias = event.action_alias;

			const isRefreshButtonEvent = event.event_type === 'ACTION_CLICK' && event.field_id;
			if (isRefreshButtonEvent) {				
				const fieldApi = getFieldAPI(formAPI, { fieldId: isRefreshButtonEvent });
				action_alias = fieldApi ? `${fieldApi.id}_refresh` : '';
			}

			subscribeBehaviorToEvent(formAPI, eventHandler, behavior, {
				...event,
				event: eventFind.property,
				element: eventFind.element,
				fieldId: event.field_id,
				gridId: event.grid_alias,
				actionId: action_alias
			})
		});
	}
};

const subscribeBehaviorToEvent = (formAPI, eventHandler, behavior, behaviorEvent) => {		
	const behaviorElementAPI = getBehaviorElementAPI(formAPI, behaviorEvent);		
	const eventName = behaviorEvent.event;
	if(behaviorElementAPI){		
		behaviorsEventsSubscriptions.push(
			behaviorElementAPI.subscribe(eventName, eventHandler.bind(this, formAPI, behavior, behaviorEvent))
		);
	}
};

const subscribeBehaviorToAllFormEvents = (formAPI, eventHandler, behavior) => {
	behaviorsEventsSubscriptions.push(
		formAPI.subscribeToAll(eventHandler.bind(this, formAPI, behavior))
	);
};

const getBehaviorElementAPI = (formAPI, behaviorEvent) => {
	const behaviorElementAPI = getFormElementAPI(formAPI, behaviorEvent);			
	if(!behaviorElementAPI){
		throw new Error(`form.errors.behavior.event.invalid_element`);
	}

	return behaviorElementAPI;
};

export default {
	subscribe,
};
